import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ResponsiveLogo from '../components/ResponsiveLogo';

const Home = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-[calc(100vh-80px)] bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <ResponsiveLogo alt="CITNC Logo" className="h-24" />
          </div>
          <h1 className="text-5xl font-bold text-slate-900 mb-4">
            CITNC AIO
          </h1>
          <p className="text-2xl text-primary font-semibold mb-4">
            All In One Student Portal
          </p>
          <p className="text-lg text-slate-600 mb-2">
            Cambridge Institute of Technology North Campus
          </p>
          <p className="text-base text-slate-500 mb-8 max-w-2xl mx-auto">
            Your unified platform for NOC requests, academic services, and all campus resources
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            {isAuthenticated ? (
              <>
                <Link 
                  to="/dashboard" 
                  className="px-8 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors shadow-lg"
                >
                  Go to Dashboard
                </Link>
                <Link
                  to="/notifications/archived"
                  className="px-8 py-3 bg-white text-primary border-2 border-primary rounded-lg font-medium hover:bg-primary hover:text-white transition-colors shadow-lg"
                >
                  View Archived Notifications
                </Link>
              </>
            ) : (
              <>
                <Link 
                  to="/login" 
                  className="px-8 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors shadow-lg"
                >
                  Login
                </Link>
                <Link 
                  to="/register" 
                  className="px-8 py-3 bg-white text-primary border-2 border-primary rounded-lg font-medium hover:bg-primary hover:text-white transition-colors shadow-lg"
                >
                  Register
                </Link>
              </>
            )}
          </div>
          <div className="grid md:grid-cols-3 gap-8 mt-16">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-4xl mb-4">🔐</div>
              <h3 className="text-xl font-semibold mb-3 text-slate-900">Secure Authentication</h3>
              <p className="text-slate-600">
                OTP-based email authentication using college email for enhanced security
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-4xl mb-4">📄</div>
              <h3 className="text-xl font-semibold mb-3 text-slate-900">NOC System</h3>
              <p className="text-slate-600">
                Streamlined No Objection Certificate requests with multi-level approvals
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-4xl mb-4">🚀</div>
              <h3 className="text-xl font-semibold mb-3 text-slate-900">Complete ERP</h3>
              <p className="text-slate-600">
                Comprehensive management system for all college operations
              </p>
            </div>
          </div>

          <div className="mt-16 bg-white rounded-xl p-8 shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-slate-900">Available Modules</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-left">
              {isAuthenticated && (
                <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="font-medium text-slate-900">✅ Archived Notifications</div>
                  <div className="text-sm text-slate-600">Expired & inactive updates</div>
                </div>
              )}
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="font-medium text-slate-900">✅ Authentication</div>
                <div className="text-sm text-slate-600">Role-based access</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="font-medium text-slate-900">✅ NOC System</div>
                <div className="text-sm text-slate-600">Request & Approval</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg opacity-60">
                <div className="font-medium text-slate-900">🔜 Attendance</div>
                <div className="text-sm text-slate-600">Coming Soon</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg opacity-60">
                <div className="font-medium text-slate-900">🔜 Fee Management</div>
                <div className="text-sm text-slate-600">Coming Soon</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg opacity-60">
                <div className="font-medium text-slate-900">🔜 Timetable</div>
                <div className="text-sm text-slate-600">Coming Soon</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg opacity-60">
                <div className="font-medium text-slate-900">🔜 Library</div>
                <div className="text-sm text-slate-600">Coming Soon</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg opacity-60">
                <div className="font-medium text-slate-900">🔜 Examination</div>
                <div className="text-sm text-slate-600">Coming Soon</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg opacity-60">
                <div className="font-medium text-slate-900">🔜 Reports</div>
                <div className="text-sm text-slate-600">Coming Soon</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Home;
